import { typo, Button, boxShadowZ1 } from '@cycle-app/ui';
import { Color } from '@cycle-app/ui/theme/baseColors';
import { lighten } from 'polished';
import styled from 'styled-components';

import { RIGHT_PANEL_WIDTH } from 'src/constants/docPanel.constants';

export const Container = styled.div`
  width: ${RIGHT_PANEL_WIDTH}px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 32px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 20px;
`;

export const Item = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  ${typo.body500};
`;

export const Label = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${p => p.theme.colors.text.secondary};
`;

export const Value = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${p => p.theme.colors.text.primary};
  overflow: hidden;
  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const ActivityContainer = styled.div`
  padding: 36px 24px 32px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${p => (p.theme.isDark ? lighten(0.02, Color.Grey900) : p.theme.colors.background.secondary)};
  color: ${p => p.theme.colors.text.secondary};
  ${typo.body400};
  strong {
    ${typo.body500};
    color: ${p => p.theme.colors.text.primary};
  }
`;

export const ActivityTitle = styled.p`
  margin-top: 15px;
  ${typo.body500};
  color: ${p => p.theme.colors.text.primary};
`;

export const ExploreButton = styled(Button).attrs({
  variant: 'outlined-alt',
  size: 'S',
})`
  margin-top: 12px;
  ${boxShadowZ1}
`;
